import { Seo } from "@/site/seo";
import { Heading } from "@/site/components/Section";

const FILES = [
  { name: "postern-marketing-site.zip", title: "Marketing website — full source (React, public/, backend marketing API)", href: "/audit/postern-marketing-site.zip", primary: true },
  { name: "AUDIT_FINDINGS.pdf", title: "Audit findings — PDF", href: "/audit/AUDIT_FINDINGS.pdf", open: true },
  { name: "AUDIT_FINDINGS.md", title: "Audit findings — Markdown", href: "/audit/AUDIT_FINDINGS.md" },
  { name: "WEBSITE_REVIEW.md", title: "Website review — Markdown", href: "/audit/WEBSITE_REVIEW.md" },
  { name: "postern-audited.bundle", title: "Git bundle — audited repository (main, audit/fixes, audit/marketing-site)", href: "/audit/postern-audited.bundle" },
];

/** Workspace-only: the audit deliverables. Not linked from the site; noindex. */
export default function DownloadsPage() {
  return (
    <>
      <Seo title="Audit downloads" noindex />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 820 }}>
          <Heading eyebrow="Technical audit · deliverables" title="Audit artefacts" lede="Confidential. Links work only while this workspace is running — save the files." />
          <div className="cards" style={{ gridTemplateColumns: "1fr 1fr" }}>
            {FILES.map((f) => (
              <div className="card" key={f.name}>
                <div className="card__t">{f.title}</div>
                <div className="mono" style={{ fontSize: 12, color: "var(--faint)", margin: "6px 0 14px" }}>{f.name}</div>
                {f.open ? <a className="btn btn--primary btn--sm" href={f.href} target="_blank" rel="noopener noreferrer">Open</a> : <a className="btn btn--primary btn--sm" href={f.href} download={f.name} data-testid={`download-${f.name}`}>Download</a>}
                {f.primary && <div className="hint" style={{ marginTop: 10, fontSize: 12, color: "var(--faint)" }}>Unzip → <code>yarn install</code> → copy <code>.env.example</code> to <code>.env</code> and set <code>REACT_APP_SITE_URL</code> to the origin you deploy on → <code>yarn build</code>.</div>}
              </div>
            ))}
          </div>
          <pre className="mono" style={{ marginTop: 24, background: "var(--ink)", color: "#f7f6f3", padding: 16, borderRadius: 8, fontSize: 12.5, overflowX: "auto" }}>{`git clone postern-audited.bundle postern-audited
cd postern-audited
git checkout audit/marketing-site   # findings + fixes + marketing API
git remote set-url origin git@github.com:<you>/<private-repo>.git
git push origin main audit/fixes audit/marketing-site`}</pre>
        </div>
      </section>
    </>
  );
}
